import React from "react";

import accounticon from '../../assets/images/accounticon.png';
import { useTranslation } from 'react-i18next';

function Accountmanagementtitle() {
  const { t } = useTranslation();
  return (
    <div className="Favourites_title Favourites_title_announce">
      <div className="Favourites_title_l">
         <img className="accounticon" src={accounticon} alt="" width="47" height="47" />
         <h2>{t('accountmanagement')}</h2>
      </div>
      <div className="Favourites_title_r">
       <p>{t('account_updatetxtmsg')}</p>
      </div>
    </div>
    );
}

export default Accountmanagementtitle;
